/**
 * /auth/sign-out
 *
 * Action route: clears the supabase-js session and sends the user to the
 * marketing site (yesplease.studio). The app is login-only; the natural
 * "logged out home" is marketing, not a portal-side surface.
 *
 * Used by the PortalLayout user menu (T-058) and the OperatorLayout user menu
 * (T-073) so sign-out is a real URL the user can bookmark and the router
 * exposes the surface explicitly.
 */

import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { signOut } from '@/lib/auth';

const MARKETING_SITE_URL = 'https://yesplease.studio';

export const Route = createFileRoute('/auth/sign-out')({
  component: SignOutPage,
});

function SignOutPage() {
  useEffect(() => {
    let cancelled = false;

    async function performSignOut() {
      await signOut();
      if (cancelled) return;
      window.location.replace(MARKETING_SITE_URL);
    }

    void performSignOut();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <p className="text-muted-foreground">Signing out...</p>
    </main>
  );
}
